import { z } from 'zod';

export const DOCUMENT_EXPORT_FILE_LIMIT = 50 * 1024 * 1024;
export const DOCUMENT_EXPORT_ARCHIVE_LIMIT = 1024 * 1024 * 1024;

export const documentExportFormatSchema = z.enum(['markdown', 'source']);
export type DocumentExportFormat = z.infer<typeof documentExportFormatSchema>;

export const documentSourceExportSchema = z.object({
  documentId: z.string().uuid(),
  maxBytes: z
    .number()
    .int()
    .positive()
    .max(DOCUMENT_EXPORT_FILE_LIMIT)
    .default(DOCUMENT_EXPORT_FILE_LIMIT),
});

export const documentExportSkipReasonSchema = z.enum([
  'unavailable',
  'empty',
  'too_large',
]);
export type DocumentExportSkipReason = z.infer<
  typeof documentExportSkipReasonSchema
>;

export const documentSourceExportResultSchema = z.discriminatedUnion('status', [
  z.object({
    status: z.literal('ready'),
    name: z.string(),
    fileName: z.string(),
    mimeType: z.string(),
    data: z.string(),
  }),
  z.object({
    status: z.literal('skipped'),
    name: z.string(),
    reason: documentExportSkipReasonSchema,
  }),
]);
export type DocumentSourceExportResult = z.infer<
  typeof documentSourceExportResultSchema
>;
